<mat-dialog-content>
  <h4 class="font-size-h4 text-center">
    {{ message }}
  </h4>

  <form class="form col-xs-12 col-md-12 p-0" *ngIf="imm_vac_periods && !taken_status">
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="example-full-width">
          <input
            [matDatepicker]="takendatepicker"
            matInput
            (click)="takendatepicker.open()"
            placeholder="Taken Date"
            [max]="today"
            #takenat
            [(ngModel)]="taken_date"
            name="taken_date"
            autocomplete="off"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="takendatepicker"
          ></mat-datepicker-toggle>
          <mat-datepicker
            #takendatepicker
            disabled="false"
            color="primary"
            touchUi
          ></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button
    mat-raised-button
    color="primary"
    [disabled]="imm_vac_periods && !taken_status && !taken_date"
    (click)="onConfirmClick()"
    tabindex="1"
  >
    {{ confirmButtonText }}
  </button>
  <button mat-raised-button mat-dialog-close tabindex="-1">
    {{ cancelButtonText }}
  </button>
</mat-dialog-actions>
